import logoViaPlus from 'assets/img/logo/logo_via_plus.png';
import React from 'react';
import {
  MdDashboard,
  MdKeyboardArrowDown,
  MdLocationOn,
  MdZoomOutMap,
  MdPerson,
  MdPermIdentity,
  MdTimerOff,
  MdDevices,
  MdFolderOpen,
  MdAssessment,
  MdKeyboardArrowRight,
  MdHistory,
  MdAccountBalanceWallet,
  MdAccountBox,
  MdDirectionsCar
} from 'react-icons/lib/md';
import { NavLink } from 'react-router-dom';
import {
  Collapse,
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import bn from 'utils/bemnames';

const navUsers = [
  { to: '/user-admin',        name: 'Administradores',  exact: false,  Icon: MdPermIdentity },
  { to: '/user-agent',        name: 'Fiscal',           exact: false,  Icon: MdPerson },
  { to: '/user-adviser',      name: 'Monitores',       exact: false,  Icon: MdPerson },
  { to: '/user-access-point', name: 'POS',              exact: false,  Icon: MdDevices },
  { to: '/user-driver',       name: 'Motoristas',       exact: false,  Icon: MdAccountBox },
];
const navVehicles = [
  { to: '/user-vehicle',      name: 'Veículos',           exact: false,  Icon: MdDirectionsCar },
  { to: '/vehicles-resident', name: 'Veículos Moradores',  exact: false,  Icon: MdTimerOff },
];
const navFix = [
  { to: '/accesspoint-credit', name: 'Crédito Lojista',   exact: false,  Icon: MdAccountBalanceWallet },
  // { to: '/credit-edit', name: 'Correção de Crédito',  exact: false,  Icon: MdMonetizationOn },
  // { to: '/plate-edit', name: 'Correção de Placa',  exact: false,  Icon: MdRepeat },
];

const navReports = [
  { to: '/report-spot', name: 'Vagas', exact: false, Icon: MdAssessment },
  { to: '/report-advisor', name: 'Vendas Monitores', exact: false, Icon: MdPermIdentity },
  { to: '/report-pos',     name: 'Vendas POS', exact: false, Icon: MdPermIdentity },
  { to: '/report-respect', name: 'Taxa de Respeito', exact: false, Icon: MdHistory},
  { to: '/report-history', name: 'Histórico de Transações', Icon: MdHistory},
  { to: '/report-parking', name: 'Histórico de Uso', exact: false, Icon: MdHistory },
  { to: '/report-report', name: 'Histórico de Reporte', exact: false, Icon: MdHistory },

  { to: '/report-cash', name: 'Histórico de Receita', exact: false, Icon: MdHistory },
  { to: '/report-sales', name: 'Histórico de Faturamento', exact: false, Icon: MdHistory },
  { to: '/report-wallet', name: 'Saldo Carteira Flutuante', exact: false, Icon: MdHistory },
  { to: '/report-flow', name: 'Relatório de Caixa', exact: false, Icon: MdHistory },

  { to: '/report-credit', name: 'Histórico de Créditos Lojista', exact: false, Icon: MdHistory },

  { to: '/report-tax', name: 'Histórico de Pagamentos de Irregularidade', exact: false, Icon: MdHistory },
  
  { to: '/report-unpaid', name: 'Histórico de Irregularidades Não Pagas', exact: false, Icon: MdHistory }

];
const navParkings = [
  { to: '/parking-spot', name: 'Vagas',   exact: false, Icon: MdLocationOn },
  { to: '/spot-types',   name: 'Tipo', exact: false, Icon: MdZoomOutMap },
];
const navItems = [
  { to: '/', name: 'Dashboard', exact: false, Icon: MdDashboard },
];
const bem = bn.create('sidebar');

export default class Sidebar extends React.Component {
  state = {
    isOpenReports: false,
    isOpenUsers: false,
    isOpenParkings: false,
    isOpenComponents: false,
    isOpenPages: false
  };
  redirectPage = link => () => {
    window.location.ref = link;
  }
  handleClick = name => () => {
    this.setState(
      prevState => {
        const isOpen = prevState[`isOpen${name}`];
        return {
          isOpenReports: false,
          isOpenUsers: false,
          isOpenParkings: false,
          isOpenComponents: false,
          isOpenPages: false,
          [`isOpen${name}`]: !isOpen,
        };
      },
    );
  };
  render() {
    return (
      <aside className={bem.b()}>
        <div className={bem.e('background')} />
        <div className={bem.e('content')} style={{overflowX: 'hidden'}}>
          <Navbar >
            <img
              src={logoViaPlus}
              width="190"
              height="60"
              className="pr-2"
              alt="Eco Parking"
            />
          </Navbar>
          <Nav vertical>
            {navItems.map(({ to, name, exact, Icon }, index) => (
              <NavItem key={index} className={bem.e('nav-item')}>
                <BSNavLink
                  id={`navItem-${name}-${index}`}
                  className=""
                  tag={NavLink}
                  to={to}
                  activeClassName="active"
                  exact={exact}>
                  <Icon className={bem.e('nav-item-icon')} />
                  <span className="">{name}</span>
                </BSNavLink>
              </NavItem>
            ))}
            <NavItem
              className={bem.e('nav-item')}
              onClick={this.handleClick('Reports')}>
              <BSNavLink className={bem.e('nav-item-collapse')}>
                <div className="d-flex">
                  <MdFolderOpen className={bem.e('nav-item-icon')} />
                  <span className="align-self-start">Relatórios</span>
                </div>
                <MdKeyboardArrowDown
                  className={bem.e('nav-item-icon')}
                  style={{
                    padding: 0,
                    transform: this.state.isOpenReports
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transitionDuration: '0.3s',
                    transitionProperty: 'transform',
                  }}
                />
              </BSNavLink>
            </NavItem>
            <Collapse isOpen={this.state.isOpenReports}>
              {navReports.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}>
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
              <NavItem key="1" className={bem.e('nav-item')}>
                <a id="navItem-moip-1"
                  title="MOIP"
                  alt="MOIP"
                  className="nav-link"
                  href="https://conta.wirecard.com.br"
                  target="__blank">
                  <MdKeyboardArrowRight className={bem.e('nav-item-icon')} />
                  <span className="">MOIP</span>
                </a>
              </NavItem>
            </Collapse>
            <NavItem
              className={bem.e('nav-item')}
              onClick={this.handleClick('Parkings')}>
              <BSNavLink className={bem.e('nav-item-collapse')}>
                <div className="d-flex">
                  <MdFolderOpen className={bem.e('nav-item-icon')} />
                  <span className=" align-self-start">Estacionamento</span>
                </div>
                <MdKeyboardArrowDown
                  className={bem.e('nav-item-icon')}
                  style={{
                    padding: 0,
                    transform: this.state.isOpenParkings
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transitionDuration: '0.3s',
                    transitionProperty: 'transform',
                  }}
                />
              </BSNavLink>
            </NavItem>
            <Collapse isOpen={this.state.isOpenParkings}>
              {navParkings.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}>
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </Collapse>
            <NavItem
              className={bem.e('nav-item')}
              onClick={this.handleClick('Users')}>
              <BSNavLink className={bem.e('nav-item-collapse')}>
                <div className="d-flex">
                  <MdFolderOpen className={bem.e('nav-item-icon')} />
                  <span className=" align-self-start">Usuários</span>
                </div>
                <MdKeyboardArrowDown
                  className={bem.e('nav-item-icon')}
                  style={{
                    padding: 0,
                    transform: this.state.isOpenUsers
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transitionDuration: '0.3s',
                    transitionProperty: 'transform',
                  }}
                />
              </BSNavLink>
            </NavItem>
            <Collapse isOpen={this.state.isOpenUsers}>
              {navUsers.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}>
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </Collapse>
            {/* Duplicated entry, removed by 22-12-08 VML */}
            {/* <Collapse isOpen={this.state.isOpenUsers}>
              {navUsers.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}>
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </Collapse> */}
            <NavItem
              className={bem.e('nav-item')}
              onClick={this.handleClick('Vehicles')}>
              <BSNavLink className={bem.e('nav-item-collapse')}>
                <div className="d-flex">
                  <MdFolderOpen className={bem.e('nav-item-icon')} />
                  <span className=" align-self-start">Veículos</span>
                </div>
                <MdKeyboardArrowDown
                  className={bem.e('nav-item-icon')}
                  style={{
                    padding: 0,
                    transform: this.state.isOpenVehicles
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transitionDuration: '0.3s',
                    transitionProperty: 'transform',
                  }}
                />
              </BSNavLink>
            </NavItem>
            <Collapse isOpen={this.state.isOpenVehicles}>
              {navVehicles.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}>
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </Collapse>
            <NavItem
              className={bem.e('nav-item')}
              onClick={this.handleClick('Fix')}>
              <BSNavLink className={bem.e('nav-item-collapse')}>
                <div className="d-flex">
                  <MdFolderOpen className={bem.e('nav-item-icon')} />
                  <span className=" align-self-start">Manutenção</span>
                </div>
                <MdKeyboardArrowDown
                  className={bem.e('nav-item-icon')}
                  style={{
                    padding: 0,
                    transform: this.state.isOpenFix
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transitionDuration: '0.3s',
                    transitionProperty: 'transform',
                  }}
                />
              </BSNavLink>
            </NavItem>
            <Collapse isOpen={this.state.isOpenFix}>
              {navFix.map(({ to, name, exact, Icon }, index) => (
                <NavItem key={index} className={bem.e('nav-item')}>
                  <BSNavLink
                    id={`navItem-${name}-${index}`}
                    className=""
                    tag={NavLink}
                    to={to}
                    activeClassName="active"
                    exact={exact}>
                    <Icon className={bem.e('nav-item-icon')} />
                    <span className="">{name}</span>
                  </BSNavLink>
                </NavItem>
              ))}
            </Collapse>            

            {/* <NavItem key="997" className={bem.e('nav-item')}>
              <BSNavLink
                id={'navItem-AccessPoint-Credit'}
                className=""
                tag={NavLink}
                to="/accesspoint-credit"
                activeClassName="active"
                exact={false}>
                <MdAccountBalanceWallet className={bem.e('nav-item-icon')} />
                <span className="">Crédito Lojista</span>
              </BSNavLink>
            </NavItem>     */}

            {/* <NavItem key="`999`" className={bem.e('nav-item')}>
              <BSNavLink
                id={'navItem-Vehicles-Resident-1'}
                className=""
                tag={NavLink}
                to="/vehicles-resident"
                activeClassName="active"
                exact={false}>
                <MdTimerOff className={bem.e('nav-item-icon')} />
                <span className="">Veíc. Moradores</span>
              </BSNavLink>
            </NavItem> */}
            {/*
            <NavItem key="9999" className={bem.e('nav-item')}>
              <BSNavLink
                id={'navItem-configuracoes-1'}
                className=""
                tag={NavLink}
                to="/configure"
                activeClassName="active"
                exact={false}>
                <MdBuild className={bem.e('nav-item-icon')} />
                <span className="">Configurações</span>
              </BSNavLink>
            </NavItem>
            */}
          </Nav>
        </div>
      </aside>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar.js